<div class="fade-in-image" style="display: flex;">
  <img _ngcontent-acf-c153="" src="assets/images/O3sigma_logo_blue.png" style="width:10rem;" alt="O3 Smart Manufacturing">
  <h1 class="main-title">Meeting Evaluation</h1>
</div>
<div class="meeting-evaluation-content" [style.pointer-events]="disableForm ? 'none' : 'auto'">
  <form [formGroup]='MeetingEvaluationForm'>
    <div style="display: flex; justify-content: center;">
      <div style="width: 75%;">
        <div class="content-top-row" style="justify-content: flex-start; margin-left: 6rem;">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing "
            style="margin-left:25px;">
            <mat-label>Meeting</mat-label>
            <input matInput formControlName="meeting" [readonly]="true" />
          </mat-form-field>
          <!-- <mat-form-field appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing " style="margin-left:10px;">
        <mat-label>Location</mat-label>
        <input matInput formControlName="location" />
      </mat-form-field> -->
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing "
            style="margin-left:10px;">
            <mat-label>Leader</mat-label>
            <input matInput formControlName="leader" [readonly]="true" />
          </mat-form-field>
          <mat-form-field [readonly]="true" appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="margin-left: 10px;">
            <input matInput [ngxMatDatetimePicker]="timePicker" placeholder="Date" formControlName="date"
              [readonly]="true" />
            <mat-datepicker-toggle matSuffix [for]="$any(timePicker)"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #timePicker> </ngx-mat-datetime-picker>
          </mat-form-field>
        </div>
      </div>
      <div style="width: 25%;">
        <div class="content-top-row" style="display:flex;">
          <div>
            <p class="top-rightbox-maintext">Score</p>
          </div>
          <div>
            <p class="top-rightbox-text" style="border-bottom: none;">0 = No</p>
            <p class="top-rightbox-text" style="border-bottom: none;">0.5 = Partial</p>
            <p class="top-rightbox-text">1 = Yes</p>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="wrapper-box wrapper-box-shadow grid-container">

    <ag-grid-angular #agGrid style="width: 100%" class="ag-theme-alpine" [modules]="modules" [columnDefs]="columnDefs"
      [rowData]="rowData" [defaultColDef]="defaultColDef" [components]="components" [suppressRowTransform]="true"
      (gridReady)="onGridReady($event)" (gridSizeChanged)="onGridSizeChanged($event)"
      (cellEditingStarted)="onCellEditingStarted($event)">
    </ag-grid-angular>
    <div class="grid-box" style="width: 100%;">
      <div style="display:flex;">
        <div style="width: 55%;">
          <h3 class="total-section">
            Total
          </h3>
        </div>
        <div style="width: 45%;">
          <div style="display: flex;">
            <p class="footer-right-section" style="border-bottom: none;">{{totalWeight}}</p>
            <p class="footer-right-section" style="border-bottom: none;">{{totalScore}}</p>
          </div>

          <p class="footer-bottom-section">{{totalScorePercentage}}%</p>
        </div>
      </div>
    </div>
    <!---Add Action Start-->
    <div mat-dialog-title>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2 style="margin-top: 20px;">AddAction</h2>
          <!-- <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button> -->
        </div>
      </div>
    </div>
    <mat-dialog-content>
      <form [formGroup]="addActionForm">
        <div class="content-row-wrap" style="margin-bottom: 20px">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0;margin-right: 0;">
            <mat-label>Action *</mat-label>
            <input matInput placeholder="Enter Action Name" formControlName="action" />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>
              Select M Classification
            </mat-label>
            <mat-select ngxMatSelect #msf1="ngxMatSelect" [displayMember]="'Name'" [valueMember]="'Id'"
              [source]="mClassificationTypes" [useInfiniteScroll]="true" formControlName="mClassification"
              [multiple]="false" [placeholder]="'Select M Classification'">
              <mat-option [value]="item.Id" *ngFor="let item of msf1.filteredSource">
                {{ item.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="radio-wrapper" style="width: 20%;display: flex;">
            <mat-label style="margin-top: 15px;font-weight: bold;">ActionType&nbsp;*:</mat-label>
            <mat-radio-group formControlName="actionType" class="radio-group" name="ActionType"
              style="margin-top: 5px;">
              <mat-radio-button value="Preventive">Preventive</mat-radio-button>
              <mat-radio-button value="Corrective">Corrective</mat-radio-button>
            </mat-radio-group>
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="background: gainsboro;">
            <mat-label>KPI</mat-label>
            <input matInput placeholder="Enter Remarks" formControlName="kpi" readonly />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px !important;">
            <mat-label>SelectAssignee *</mat-label>
            <!-- <mat-select formControlName="assignTo"> -->
            <!-- <mat-select-filter [placeholder]="'Search User'" [displayMember]="'fullName'" [array]="participantsByPlants"
            (filteredReturn)="userList = $event">
          </mat-select-filter> -->
            <mat-select ngxMatSelect #msDepart="ngxMatSelect" [displayMember]="'fullName'"
              [valueMember]="'employeeCode'" [source]="userList" [useInfiniteScroll]="true" formControlName="assignTo"
              [multiple]="false">
              <mat-option *ngFor="let user of msDepart.filteredSource" [value]="user?.employeeCode">
                {{ user?.fullName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="inputField" style="width: 17%;margin-top: 0px;margin-left:30px;margin-right: 0;">
            <nz-date-picker class="calender-input" style="margin-left: 0px !important; width: 100%" [nzShowTime]="false"
              nzFormat="yyyy-MM-dd" formControlName="targetDate">
            </nz-date-picker>
            <span class="floating-text">TargetDate *</span>
          </div>
          <button [disabled]="!addActionForm.valid" mat-mini-fab mat-button color="primary" matTooltip="Add"
            matTooltipClass="custom-tooltip" matTooltipPosition="above" style="margin-left: 10px;"
            (click)="addActionPlan()">
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>
        </div>
      </form>
      <ag-grid-angular style="width: 100%; height: 20vw" class="ag-theme-alpine" [pagination]="true"
        [paginationAutoPageSize]="5" [columnDefs]="columnDefsallAction" [rowData]="overallMeetingActions"
        (cellClicked)="cellClickedActionTable($event)">
      </ag-grid-angular>
    </mat-dialog-content>
    <!---Add Action End-->
    <ng-template #actionPlanModal>
      <form [formGroup]="editActionPlanForm">
        <div mat-dialog-title>
          <div mat-dialog-title>
            <div class="d-flex justify-content-between align-items-center">
              <h2>Update Action</h2>
              <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
                <i class="fa fa-times" style="color: #fff"></i>
              </button>
            </div>
          </div>
        </div>
        <mat-dialog-content>
          <div class="content-row-wrap" style="margin-bottom: 20px"><!---->
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>Root Cause</mat-label>
              <input matInput placeholder="Enter Remarks" formControlName="rootcause" />
            </mat-form-field>
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>Action *</mat-label>
              <input matInput placeholder="Enter Action Name" formControlName="actions" [(ngModel)]="data.Action" />
            </mat-form-field>

            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>
                Select M Classification
              </mat-label>
              <mat-select ngxMatSelect #msf2="ngxMatSelect" [displayMember]="'Name'" [valueMember]="'Id'"
                [source]="mClassificationTypes" [useInfiniteScroll]="true" formControlName="mClassification"
                [multiple]="false" [placeholder]="'Select M Classification'">
                <mat-option [value]="item.Id" *ngFor="let item of msf2.filteredSource">
                  {{ item.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="radio-wrapper" style="display: flex;width: 20%;">
              <mat-label style="font-weight: bold;margin-top: 28px;margin-left: 10px;">ActionType&nbsp;*:</mat-label>
              <mat-radio-group formControlName="actionType" class="radio-group" name="ActionType"
                style="margin-top: 20px;margin-left: 20px;">
                <mat-radio-button value="Preventive">Preventive</mat-radio-button>
                <mat-radio-button value="Corrective">Corrective</mat-radio-button>
              </mat-radio-group>
            </div>
            <!-- <div class="radio-wrapper" style="width: 20%;display: flex;" >
          <mat-label style="margin-top: 15px;font-weight: bold;">ActionType&nbsp;*:</mat-label>
          <mat-radio-group formControlName="actionType" class="radio-group" name="ActionType" style="margin-top: 5px;">
            <mat-radio-button value="Preventive">Preventive</mat-radio-button>
            <mat-radio-button value="Corrective">Corrective</mat-radio-button>
          </mat-radio-group>
        </div> -->
            <div class="imgFlex-Wrapper">
              <mat-label>Choose Image</mat-label>
              <div class="imgflex" style="position: relative;margin-top: 5px;">
                <div style="display: flex">
                  <div title="image" style="margin-right: 5px;">
                    <img *ngIf="data.FileSrc || data.UploadFile" (click)="imageZoomModal()"
                      [src]="data.FileSrc || blobStorageUrl + data.UploadFile" alt="image" width="60px" height="40px" />
                  </div>
                  <img *ngIf="data.FileSrc || data.UploadFile" src="assets/images/delete.png"
                    (click)="deleteFile('pic')" class="imgabsol" alt="" width="15px" height="15px"
                    style="position: absolute; left: 0; top: 0" />
                  <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile('pic')">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <input type="file" (change)="readFile($event, 'pic')" class="d-none" #fileInput accept="image/*" />
                </div>
              </div>
            </div>
            <div class="imgFlex-Wrapper" style="margin-left: 20px;">
              <mat-label>Choose File</mat-label>
              <div class="imgflex" style="position: relative;margin-top: 5px;">
                <div style="display: flex">
                  <div title="pdf">
                    <a *ngIf="data.DocSrc || data.UploadDoc" (click)="downloadPDF()"><img
                        src="assets/images/file_img.png" class="pdfimg" alt="pdf" width="60px" height="40px" /></a>
                  </div>
                  <img *ngIf="data.DocSrc || data.UploadDoc" src="assets/images/delete.png" (click)="deleteFile('file')"
                    class="imgabsol" alt="" width="15px" height="15px" style="position: absolute; left: 0; top: 0" />
                  <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile(i, 'file')"
                    [disabled]="data.Status == 'Closed'">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <input type="file" (change)="readFile($event, 'file')" class="d-none" #fileInputFile
                    accept="application/pdf,application/vnd.ms-excel" />
                </div>
              </div>
            </div>
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>Select Assignee *</mat-label>
              <mat-select formControlName="assignTo" [disabled]="data.Status == 'Closed' || !data.Action">
                <mat-select-filter [placeholder]="'Search User'" [displayMember]="'fullName'"
                  [array]="participantsByPlants" (filteredReturn)="userList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let user of userList" [value]="user?.employeeCode">
                  {{ user?.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="inputField" style="margin-top: 15px; width: 17% ;margin-left: 25px;">
              <!-- <nz-date-picker class="calender-input"  nzFormat="dd/MM/yyyy"
                  [nzInputReadOnly]="true" style="width: 100%; margin-left: 0px !important;"
                  [nzDisabledDate]="getMinDate('Target')" [disabled]="'true'"  [(ngModal)] = "data.TargetDate"></nz-date-picker> -->
              <nz-date-picker class="calender-input" style="margin-left: 0px !important; width: 100%"
                [nzInputReadOnly]="true" [nzShowTime]="false" nzFormat="yyyy-MM-dd"
                [nzDisabledDate]="getMinDate('Target')" formControlName="targetDate"
                (nzOnCalendarChange)="targetChange()" [nzDisabled]="data.Status != 'Open' || !data.AssignTo"
                [(ngModel)]="data.TargetDate">
              </nz-date-picker>
              <span class="floating-text">TargetDate *</span>
            </div>
            <div class="inputField" style="margin-top: 15px; width: 17% ; margin-left: 20px;">
              <nz-date-picker class="calender-input" formControlName="revisedDate" nzFormat="yyyy-MM-dd"
                [nzInputReadOnly]="true" style="width: 100%; margin-left: 0px !important"
                [nzDisabledDate]="getMinDate('Revised')" [nzDisabled]="
               (data.Status != 'InProgress' && data.Status == 'Open') ||
               data.Status == 'Complete' ||
               data.Status == 'Closed'
               ">
              </nz-date-picker>
              <span class="floating-text">RevisedDate</span>
            </div>
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" [ngClass]="{
               'disabled-input':
               data.Status == 'Closed' ||
               !data.TargetDate ||
               data.Status == 'Complete'
               }">
              <mat-label>Select Completed</mat-label>
              <mat-select formControlName="completed" (selectionChange)="onChangeComplete()" [disabled]="
               data.Status == 'Closed' ||
               !data.TargetDate ||
               data.Status == 'Complete'
               ">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="No">No</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              [ngClass]="{ 'disabled-input': disableVerification }">
              <mat-label>Select Verfication</mat-label>
              <mat-select formControlName="verification" [disabled]="addDisableVerification"
                (selectionChange)="onChangeVerification()">
                <mat-option value="">None</mat-option>
                <mat-option value="Approved">Approved</mat-option>
                <mat-option value="Disapproved">Disapproved</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              [ngClass]="{ 'disabled-input': af?.completed?.value == 'No' }">
              <mat-label>Select New Assignee</mat-label>
              <mat-select [disabled]="af?.completed?.value == 'No'" formControlName="NewAssignee">
                <mat-select-filter [placeholder]="'Search New Assignee'" [displayMember]="'FullName'"
                  [array]="participantsByPlants" (filteredReturn)="userList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let user of userList" [value]="user.EmpInfo_Id">
                  {{ user?.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="p-xl-4 uploadinside" *ngIf="showinput" style="width: fit-content">
              <input placeholder="Choose Close File" type="file" (change)="uploadedFile($event)"
                formControlName="closefile" class="form-control"
                style="height: 48.31px; width: 219px; margin-top: 8px" />
            </div>
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>Remarks</mat-label>
              <input matInput placeholder="Enter Remarks" formControlName="remarks" />
            </mat-form-field>
            <button mat-mini-fab mat-button color="primary" matTooltip="Update" (click)="UpdateActionPlan()"
              matTooltipClass="custom-tooltip" matTooltipPosition="above" style="margin-left: 20px; margin-top: 20px">
              <i class="fa fa-pencil" style="color: #fff"></i>
            </button>
          </div>
        </mat-dialog-content>
      </form>
    </ng-template>
    <!---Add Action End-->
    <!-- <button type="button" mat-mini-fab mat-button (click)="addNewRow()" color="accent" pTooltip="Add New Row"
      tooltipPosition="top" style="margin-top: 16px;">
      <i class="fa fa-plus" style="color: #fff"></i>
    </button>
    <ag-grid-angular #agGrid style="width: 100%; height: 300px; margin-top: 30px;" class="ag-theme-alpine"
      [modules]="modules" [columnDefs]="columnDefs1" [rowData]="rowData1" [gridOptions]="gridOptions"></ag-grid-angular> -->

    <div *ngIf="successMessage !== ''" class="success_message">
      <h2>{{successMessage}}</h2>
    </div>
    <div *ngIf="successMessage === ''" style="margin-top: 20px;">
      <h3 *ngIf="isSaving" style="font-weight: bold; color:#49FFB9; margin-top: 20px;">
        Saving Data...</h3>
      <button *ngIf="!isSaving && !isEvaluationFilled" mat-flat-button color="accent" (click)="saveRecord()"
        class="btn-accent-big">
        Save Record
      </button>
    </div>
  </div>
</div>